import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "NaNoWriMo day19, so not gonna make it",
  "description": "",
  "published": "2009-11-19T00:00:00.000Z",
  "redirect_from": ["/blog/nanowrimo-day19-so-not-gonna-make-it/swizec/891"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For the past few days I've been writing like mad, today especially, mad mad amounts of writing!`}</p>
    <p>{`But then I found out it took me seven fucking days to write a proper day's quota, that is to say, I only wrote a bloody 1700 words. But anyway, here they are.`}</p>
    <blockquote>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      